var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"disclaimer"},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v("Disclaimer")]),_c('div',{staticClass:"content"},[_c('p',[_vm._v("Your disclaimer content here...")])])])])
}]

export { render, staticRenderFns }